<template>
  <div class="newMemberRewards">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>营销</el-breadcrumb-item>
      <el-breadcrumb-item>营销管理</el-breadcrumb-item>
      <el-breadcrumb-item>新会员奖励设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="boxLayout">
      <h3 class="title-t">基础信息</h3>
      <el-form :model="basicInfoForm" label-width="120px">
        <el-form-item label="是否启用" prop="status">
          <el-switch
            v-model="basicInfoForm.status"
            :active-value="1"
            :inactive-value="2"
            active-color="#13ce66"
            inactive-color="gray"
          >
          </el-switch>
          <span class="tip-text">启用后，对此刻之后新进入小程序的用户自动静默发放</span>
        </el-form-item>
        <el-form-item label="最近启用时间" v-if="basicInfoForm.enable_time">
          <span>{{ basicInfoForm.enable_time }}</span>
        </el-form-item>
        <el-form-item label="奖励内容" prop="name">
          <el-checkbox
            v-model="basicInfoForm.is_score"
            label="积分奖励"
          ></el-checkbox>
          <el-input
            v-if="basicInfoForm.is_score == true"
            v-model="basicInfoForm.score"
            class="ipt"
            placeholder="请输入"
            ><template slot="prepend">币</template></el-input
          >
          <br />
          <el-checkbox
            label="优惠券（多选）"
            v-model="basicInfoForm.is_coupon"
          ></el-checkbox>
          <el-button
            type="text"
            @click="selectCouponDialogVisible = true"
            v-if="basicInfoForm.is_coupon == true"
            >+ 选择优惠券</el-button
          >
          <el-table :data="couponList" border v-if="couponList.length > 0">
            <el-table-column type="index" label="序号" width="55">
            </el-table-column>
            <el-table-column prop="name" label="优惠券名称"></el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="活动说明">
          <wangEditorTool
            ref="editors"
            :content="basicInfoForm.desc"
            v-if="basicInfoForm.desc !== ''"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="operateBtn">
      <el-button size="mini" type="primary" @click="submit">保存</el-button>
    </div>
    <selectCoupon
      :coupons="couponList"
      :releaseType="'6'"
      :dialogVisible="selectCouponDialogVisible"
      @confirmCoupon="confirmCoupon"
      @closeDialog="closeDialog"
    />
  </div>
</template>
<script>
import wangEditorTool from "../../../components/wangEditorTool.vue";
import selectCoupon from "../../../components/selectCoupon.vue";
export default {
  name: "newMemberRewards",
  components: { wangEditorTool, selectCoupon },
  data() {
    return {
      selectCouponDialogVisible: false,
      couponList: [],
      basicInfoForm: {
        status: 2,
        is_score: "",
        is_coupon: "",
        score: "",
        desc: "",
        enable_time: "",
      },
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.axios({
        method: "get", //请求方法
        headers: {
          "Content-Type": "application/json",
          "X-Access-Token": this.storage.get("__token"),
          Authorization: `Bearer ${this.storage.get("__token")}`,
        },
        url: ` https://time.api.boyalife.cn/v1/cms/NewAward/1`,
      })
        .then((res) => {
          let a = res.data.result;
          for (let i in a) {
            this.basicInfoForm[i] = a[i];
          }
          this.couponList = this.basicInfoForm.coupon || [];
          this.basicInfoForm.status = Number(this.basicInfoForm.status);
          this.basicInfoForm.is_score =
            this.basicInfoForm.is_score == 1 ? true : false;
          this.basicInfoForm.is_coupon =
            this.basicInfoForm.is_coupon == 1 ? true : false;
          this.basicInfoForm.desc =
            this.basicInfoForm.desc == "" ? "<br>" : this.basicInfoForm.desc;
        })
        .catch((err) => {
          this.$message.error(err.response.data.error.message);
        });
    },
    confirmCoupon(row) {
      this.couponList = row;
      this.selectCouponDialogVisible = false;
      this.basicInfoForm.coupon_uuid = row.map((item) => item.uuid);
    },
    closeDialog() {
      this.selectCouponDialogVisible = false;
    },
    submit() {
      this.basicInfoForm.desc = this.$refs.editors.html;
      if (this.basicInfoForm.is_coupon == false) {
        this.basicInfoForm.coupon_uuid = [];
      } else if (
        !this.basicInfoForm.coupon_uuid ||
        this.basicInfoForm.coupon_uuid.length === 0
      ) {
        this.basicInfoForm.coupon_uuid = this.couponList.map((c) => c.uuid);
      }
      if (
        this.basicInfoForm.status == 1 &&
        this.basicInfoForm.is_score == true &&
        (!this.basicInfoForm.score || Number(this.basicInfoForm.score) <= 0)
      ) {
        this.$message.error("勾选积分奖励时，积分值必须大于 0");
        return false;
      }
      if (
        this.basicInfoForm.status == 1 &&
        this.basicInfoForm.is_coupon == true &&
        (!this.basicInfoForm.coupon_uuid ||
          this.basicInfoForm.coupon_uuid.length === 0)
      ) {
        this.$message.error("勾选优惠券奖励时，至少选择一张优惠券");
        return false;
      }
      const payload = {
        status: this.basicInfoForm.status,
        is_score: this.basicInfoForm.is_score == true ? 1 : 2,
        is_coupon: this.basicInfoForm.is_coupon == true ? 1 : 2,
        score: this.basicInfoForm.score,
        desc: this.basicInfoForm.desc,
        coupon_uuid: this.basicInfoForm.coupon_uuid,
      };
      this.axios({
        method: "put", //请求方法
        headers: {
          "Content-Type": "application/json",
          "X-Access-Token": this.storage.get("__token"),
          Authorization: `Bearer ${this.storage.get("__token")}`,
        },
        data: payload,
        url: ` https://time.api.boyalife.cn/v1/cms/NewAward/1`,
      })
        .then((res) => {
          this.$message.success("保存成功！");
          this.getInfo();
        })
        .catch((err) => {
          this.$message.error(err.response.data.error.message);
        });
    },
  },
};
</script>
<style scoped>
.newMemberRewards {
  margin-bottom: 80px;
}
>>> .ipt {
  width: 200px;
  margin: 0 10px;
}
.tip-text {
  margin-left: 12px;
  color: #999;
  font-size: 12px;
}
</style>
